import { ENV } from '@/constants';

export const getFbPixelId = () => ENV.FB_PIXEL_ID;
